import request from '@/utils/request'

// 查询
export function getCenterDataByUnion (data) {
  return request.get('/system/dataCenter/tenant/info',data)
}